import React, { useEffect } from 'react';
import AppSidebar from './common/AppSidebar';
import SEO from './SEO';

const legalServices = [
  { name: 'Conveyancing', description: 'Handling the legal aspects of buying and selling property.' },
  { name: 'Employment', description: 'Advising on employment contracts, disputes, and regulations.' },
  { name: 'Family', description: 'Dealing with matters such as divorce, child custody, and adoption.' },
  { name: 'Personal Injury', description: 'Assisting clients who have been injured due to negligence.' },
  { name: 'Wills, Trust & Probate', description: 'Helping with estate planning, wills, and inheritance matters.' },
  { name: 'Money & Tax', description: 'Providing advice on financial and tax-related legal issues.' },
  { name: 'Immigration', description: 'Assisting with visas, residency, and citizenship applications.' },
  { name: 'Divorce', description: 'Handling the legal process of dissolving a marriage.' },
  { name: 'Company & Commercial', description: 'Advising businesses on corporate and commercial law.' },
  { name: 'Commercial Property', description: 'Dealing with legal aspects of commercial real estate.' },
  { name: 'Litigation', description: 'Handling disputes and lawsuits in court.' },
  { name: 'Intellectual Property', description: 'Protecting patents, trademarks, and copyrights.' },
  { name: 'Banking & Finance', description: 'Advising on financial transactions and regulations.' },
  { name: 'Criminal Law', description: 'Defending clients accused of crimes.' },
  { name: 'Landlord & Tenant', description: 'Dealing with disputes between landlords and tenants.' },
  // Add more services as needed
];

const LegalServicesPage = () => {
  // Set data-page attribute on body for CSS targeting
  useEffect(() => {
    document.body.setAttribute('data-page', 'home');
    
    return () => {
      document.body.removeAttribute('data-page');
    };
  }, []);

  return (
    <>
      <SEO 
        fallbackTitle="Legal Services - Zahoot"
        fallbackDescription="Explore the legal services available through Zahoot AI. Find solicitors for various legal matters including family law, conveyancing, employment and more."
      />
      <div className="home-page">
        {/* Sidebar Navigation */}
        <AppSidebar />
        
        <main className="home-page__main">
          <div className="max-w-6xl w-full px-4 lg:right-9 sm:px-6 lg:px-8 mx-auto z-5 relative">
            <div className="text-center mb-12 z-5 relative pt-8">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
                Legal <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D80364] to-[#F0654B]">Services</span>
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Find experts in these practice areas to help with your legal needs
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {legalServices.map((service) => (
                <div key={service.name} className="bg-purple-900/50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                  <h2 className="text-xl font-semibold mb-3 text-white">{service.name}</h2>
                  <p className="text-gray-300">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default LegalServicesPage; 